import React, { useEffect } from "react";
import BottomImage from "../../assets/BottomFrame.png";
import CenterImage from "../../assets/CenterImage.png";
import "./FeedbackPwdPage.scss";
import { useNavigate, useLocation } from "react-router-dom";

export default function FeedbackPwdPage() {
  const location = useLocation();
  const { requestPwd } = location.state || {};
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/login");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="feedback-page">
      <div className="feedback-content">
        <div className="centerDiv">
          <div className="ticketyHeader">tickety</div>
          {requestPwd && requestPwd == "yes" ? (
            <>
              <div className="resetHeader">Request Sent to Admin </div>
            </>
          ) : (
            <>
              <div className="resetHeader">Password Changed </div>
            </>
          )}

          {requestPwd && requestPwd == "yes" ? (
            <>
              <div className="resetText">
                The new password will be sent to you soon.
              </div>
            </>
          ) : (
            <>
              <div className="resetText">
                You can login again with a new password
              </div>
            </>
          )}

          <img
            src={CenterImage}
            alt="Center Decorative"
            height={"50%"}
            width={"50%"}
          />
        </div>
      </div>
      <div className="bottom-image">
        <img src={BottomImage} alt="Bottom Decorative" />
      </div>
    </div>
  );
}
